<div class="test-exe-info-box">
  <div class="test-exe-graph-box">
    <div>
      <doughnut-chart
        [graphVaule]="partData.graphVaule"
        [title]="partData.title"
        *ngIf="partData.graphVaule != null"
        style="width: 8em; height: 9em; display: block;">
      </doughnut-chart>
    </div>
    <div>
      <div class="test-exe-graph-text"
        [ngClass]="partData.title != '안구조절' ?
          (partData.graphVaule < 40 ? 'test-text-instability' : (partData.graphVaule < 80 ? 'test-text-guard' : 'test-text-stability')) :
          (partData.graphVaule != 0 ? 'test-text-instability' : 'test-text-stability')">
        {{ partData.title != '안구조절' ? (partData.graphVaule < 40 ? '불안정' : (partData.graphVaule < 80 ? '경계' : '안정')) : ''}}
        {{ partData.title == '안구조절' ? (partData.graphVaule != 0 ? '불안정' : '안정') : ''}}
      </div>
    </div>
  </div>
  <div class="test-exe-text-box">
    <div class="test-exe-text-title">
      {{partData.title}}
    </div>
    <div class="test-exe-text-content">
      {{partData.titleInfo}}
    </div>
    <img class="test-exe-text-line" src="assets/images/inspection_line.png">
    <div class="test-exe-text-second test-exe-text-content">
      {{partData.info}}
    </div>
  </div>
</div>
